import React, { useEffect } from "react";
import { Box, Container, Grid, Typography, Link, Tooltip } from "@mui/material";
import ky from "ky";

export const Footer = () => {
  const [apiVersion, setApiVersion] = React.useState("");
  const appVersion = window._env_.REACT_APP_VERSION;
  const footerRef = React.useRef(null);

  useEffect(() => {
    ky.get(window._env_.REACT_APP_API_URL + "/actuator/info", {
      timeout: window._env_.REACT_APP_TIMEOUT,
    })
      .json()
      .then((response) => {
        setApiVersion(response.app.version);
      })
      .catch((e) => {
        setApiVersion("unknown");
        console.error(e);
      });
  }, []);

  return (
    <Box
      ref={footerRef}
      sx={{
        width: "100%",
        height: "auto",
        backgroundColor: "primary.main",
        mt: 2,
        paddingTop: "1rem",
        paddingBottom: "1rem",
      }}
    >
      <Container maxWidth="lg">
        <Grid container direction="column" alignItems="center">
          <Grid item xs={12}>
            <Tooltip title="Jessie helped too :p" arrow>
              <Typography
                color="primary.contrastText"
                variant="subtitle1"
                align="center"
              >
                Copyright{" "}
                <Link
                  href="https://byerline.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  Jacob Byerline
                </Link>{" "}
                © {new Date().getFullYear()}
              </Typography>
            </Tooltip>
            {appVersion && (
              <Typography
                color="primary.contrastText"
                variant="caption"
                align="center"
                sx={{ display: "grid" }}
              >
                UI: v{appVersion}{" "}
                {!["", "unknown"].includes(apiVersion) && "API: v" + apiVersion}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
